package com.presentocracy.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class AuthProvider {
    EMAIL_PASSWORD,
    GOOGLE,
}

@Serializable
data class Birthday(
    val day: Int,
    val month: Int,
    val year: Int? = null,
)

@Serializable
data class UserProfile(
    val id: String,
    val username: String,
    val displayName: String,
    val email: String,
    val avatarUrl: String? = null,
    val bio: String? = null,
    val birthday: Birthday? = null,
    val heightCm: Int? = null,
    val showBirthYear: Boolean = false,
    val preferredCurrency: String = "EUR",
    val emailVerified: Boolean = false,
)

@Serializable
data class SessionTokens(
    val accessToken: String,
    val refreshToken: String,
    val expiresInSeconds: Long,
)

@Serializable
data class AuthenticatedUser(
    val user: UserProfile,
    val tokens: SessionTokens,
)
